<template>
    <woot-modal :show.sync="showModal" :on-close="hideAddHookModal">
    <woot-modal-header
      :header-title="$t('INTEGRATION_APPS.HIRE_PLAN.TITLE')"
    />

    <div class="column content-box">

      <p>{{ $t('INTEGRATION_APPS.HIRE_PLAN.MESSAGE_1', { integrationName }) }}</p>

      <p> {{ integrationDescription }} </p>

      <p>
        {{  $t('INTEGRATION_APPS.HIRE_PLAN.MSG_GET_IN_TOUCH') }}
      </p>
      <a class="btn-primary" href="http://wa.me/553198795790" target="_blank">{{$t('INTEGRATION_APPS.HIRE_PLAN.CLICK_HERE') }}</a>
    </div>
    </woot-modal>
</template>

<script>

export default {
  name: 'HirePlanModal',
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    integration: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    integrationName() {
      return this.integration.name || '';
    },

    integrationDescription() {
      if (!this.integration.id) return '';
      return this.$t(`INTEGRATION_APPS.HIRE_PLAN.${this.integration.id.toUpperCase()}_DESC`);
    },

    integrationsDescFooter() {
      if (!this.integration.id) return '';
      return  this.$t(`INTEGRATION_APPS.HIRE_PLAN.${this.integration.id.toUpperCase()}_DESC`);
    }
  },

  methods: {
    hideAddHookModal() {
      this.$emit('hide-modal-hire-plan');
    }
  }
};


</script>

<style scoped>
.column.content-box {
  padding: 1rem 3rem;
}

p {
  margin-bottom: 1rem;
}
</style>